export const breakpoints = {
  mobile: 0,
  tablet: 744,
  desktop: 1280,
  large: 2560,
}
